import { Columns } from '@shared/interfaces/table/column-config';
import { datahubPartial } from '@shared/partials/datahub.partial';
import { AggregatedMeteredDataDto } from '@app/api/dmc';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { businessReasonCodePartial } from '@shared/partials/business-reason-code.partial';
import { resolutionPartial } from '@shared/partials/resolution.partial';
import { productIdentificationPartial } from '@shared/partials/product-identification.partial';
import { unitTypePartial } from '@shared/partials/unit-type.partial';
import { meteringPointTypePartial } from '@shared/partials/meteringpointtype-partial.table';
import { settlementmethodPartial } from '@shared/partials/settlementmethod.partial';

export const settlementMeteredMasterdata: Columns<AggregatedMeteredDataDto>[] = [
  datahubPartial as Columns<AggregatedMeteredDataDto>,
  {
    title: 'common.date.received',
    key: 'createdTS',
    cellRenderer: DateCellComponent
  },
  {
    title: 'common.date.start',
    key: 'startDate',
    cellRenderer: DateCellComponent
  },
  {
    title: 'common.date.end',
    key: 'endDate',
    cellRenderer: DateCellComponent
  },
  businessReasonCodePartial as Columns<AggregatedMeteredDataDto>,
  resolutionPartial as Columns<AggregatedMeteredDataDto>,
  productIdentificationPartial as Columns<AggregatedMeteredDataDto>,
  unitTypePartial as Columns<AggregatedMeteredDataDto>,
  {
    ...meteringPointTypePartial,
    key: 'typeOfMeteringPoint',
  },
  settlementmethodPartial as Columns<AggregatedMeteredDataDto>,
  {
    title: 'common.version.title',
    key: 'version',
  }
];
